import { render, staticRenderFns } from "./LessonSelect.vue?vue&type=template&id=5ba57637&scoped=true"
import script from "./LessonSelect.vue?vue&type=script&lang=js"
export * from "./LessonSelect.vue?vue&type=script&lang=js"
import style0 from "./LessonSelect.vue?vue&type=style&index=0&id=5ba57637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba57637",
  null
  
)

export default component.exports